/**
 * @fileOverview
 * 为了解决Redux的循环依赖的问题，采取依赖注入的方式
 * @author iNahoo
 * @since 2018/7/25.
 */


import React from 'react';
import { Provider } from 'react-redux';
import { Dialog } from '../../components/FunctionalDialog';
import classNames from 'classnames';


import zhCN from 'antd/lib/locale-provider/zh_CN';
import { LocaleProvider, Modal, Button, ConfigProvider } from 'antd';
import styles from './index.less';

// 定义需要注入的依赖
const Deps = {
  store: null,
};

class DialogWithAntdLocale extends Dialog {
  render(Component, props, configs) {
    return (<LocaleProvider locale={zhCN}>
      <ConfigProvider autoInsertSpaceInButton={false}>
        {super.render(Component, props, configs)}
      </ConfigProvider>
    </LocaleProvider>);
  }
}


class DialogWithRedux extends DialogWithAntdLocale {
  render(Component, props, configs) {
    return (<Provider store={Deps.store}>
      {super.render(Component, props, configs)}
    </Provider>);
  }
}

class DialogWithModal extends DialogWithAntdLocale {
  render(Component, props = {}, configs) {
    console.log('props', props);
    const {
      title = '',
      footer = true, // 是否展示弹窗脚
      display = false, // 是否不展示确认，纯数据展示
      align = '',
      width,
      className: oClassName
    } = props;

    return (<Provider store={Deps.store}>
      <Modal
        className={[styles.Dialog +" "+ oClassName]}
        title={title}
        visible
        width={width || 560}
        onCancel={props.destroy}
        onOk={this.wrapSuccess}
        maskClosable={false}
        footer={footer && (
          <div className={classNames({
            'ant-btn-wrap-custom': true,
            'ant-btn-wrap-custom-center': align === 'center',
          })}
          >
            {
              !display && (<Button
                key="submit"
                type="primary"
                onClick={() => {
                  const { getWrappedInstance } = this.instance;
                  if (getWrappedInstance) { // 通过getWrappedInstance来判断是否有connect包裹
                    if (this.instance.wrappedInstance) { // 如果设置了withRef
                      return this.instance.wrappedInstance.onSuccess();
                    }
                    // 如果没设置，则需要一层层找
                    this.instance._reactInternalFiber.child.stateNode.onSuccess();
                  }
                  const { onSuccess = () => {} } = this.instance;
                  onSuccess();
                }}
              >确认</Button>)
            }
            <Button key="back" onClick={props.destroy}>取消</Button>
          </div>)
        }
      >
        {super.render(Component, {
          ...props,
          ref: (instance) => {
            if (instance) {
              this.instance = instance;
            }
          },
        }, { ...configs, fullScreen: false })}
      </Modal>
    </Provider>);
  }
}


/**
 * 依赖注入
 * @param store
 */
function injectionDeps({ store }) {
  if (!Deps.store) Deps.store = store;
}

const createFunctionalDialogWithRedux = DialogWithRedux.create.bind(DialogWithRedux);
const createFunctionalDialog = DialogWithAntdLocale.create.bind(DialogWithAntdLocale);
const dialog = DialogWithAntdLocale.create.bind(DialogWithModal);

export {
  createFunctionalDialogWithRedux,
  createFunctionalDialog,
  injectionDeps,
  dialog,
};




// WEBPACK FOOTER //
// ./src/utils/FunctionalDialog/index.js